export default __webpack_public_path__ + "static/media/ForgotPassword.bda81ddb.txt";